//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  components: {  },
  props: ["group"],
  computed: {

  },
  data() {
    return {
      deviceNamesDevice: [],
      deviceNamesGroup: [],
      deviceNamesDeviceAndGroup: []
    };
  },
  created() {
    const devices = this.group.devices.slice();
    for(let device of devices) {
      if(device.playlistHeredity === 'device') {
        this.deviceNamesDevice.push(device.NAME);
      } else if(device.playlistHeredity === 'group') {
        this.deviceNamesGroup.push(device.NAME);
      } else {
        this.deviceNamesDeviceAndGroup.push(device.NAME);
      }
    }
  },
  methods: {
	
  },
};
